"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "UserActionRecord", {
    enumerable: true,
    get: function() {
        return UserActionRecord;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const UserActionRecord = _zod.z.object({
    /** Foreign key - user document */ user_id: _zod.z.instanceof(_bson.ObjectId),
    time_stamp: _zod.z.instanceof(Date).default(()=>new Date())
});
